import { useSsrStore } from 'src/stores/ssr'
import schemaLdJson from 'src/seo/schemaLdJson'

export default class extends schemaLdJson {
  constructor($this) {
    super($this)
    this.$this = $this
    this.manufacturer = $this.manufacturer
  }

  author() {
    return {
      '@type': 'Organization',
      name: this.manufacturer.code,
      url: `${this.URL}/ru/games/${this.manufacturer.code}`,
      logo: {
        '@type': 'ImageObject',
        url: `${this.URL}${this.manufacturer.image}`,
        width: '186',
        height: '73',
      },
    }
  }

  capitalizeProvider() {
    const code = this.manufacturer.code

    return code ? code.charAt(0).toUpperCase() + code.slice(1) : ''
  }

  generate() {
    const $this = this.$this

    const image = useSsrStore().gameObjectData.compressedImage
      ? (useSsrStore().gameObjectData.compressedImage.webp?.md ?? null)
      : null

    const json = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      url: `${this.URL}/ru/games/${this.manufacturer.code}/${useSsrStore().gameObjectData.slug}`,
      name: useSsrStore().gameObject.game.name,
      datePublished: useSsrStore().gameObjectData.created,
      dateModified: useSsrStore().gameObjectData.updated,
      description: $this.metaDesc,
      isPartOf: this.isPartOf(),
      publisher: this.publisher(),
      potentialAction: {
        '@type': 'PlayAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${this.URL}/ru/games/${this.manufacturer.code}/${useSsrStore().gameObjectData.slug}`,
          actionApplication: {
            '@type': 'SoftwareApplication',
            name: useSsrStore().gameObjectData.name,
            image: '',
            description: `Игровой автомат ${useSsrStore().gameObjectData.name} от провайдера ${
              this.manufacturer.code
            }. Это бесплатная демо версия - в нее можно играть без регистрации в онлайн-казино Олимп. Желаем вам приятной игры!`,
            applicationCategory: 'Game',
            applicationSubCategory: 'Slot Machine',
            genre: ['Slots', 'Online Slots', 'Casino Game'],
            datePublished: useSsrStore().gameObjectData.created,
            processorRequirements: '1 GHz',
            memoryRequirements: '1 Gb',
            storageRequirements: '2 Gb',
            operatingSystem: ['Multi-platform', 'Windows', 'Andorid', 'IOS', 'Linux'],

            author: this.author(),
          },
        },
      },
      mainEntity: {
        '@type': 'VideoGame',
        name: useSsrStore().gameObjectData.name,
        image: '',
        description: `Игровой автомат ${useSsrStore().gameObjectData.name} от провайдера ${
          this.manufacturer.code
        }. Это бесплатная демо версия - в нее можно играть без регистрации в онлайн-казино Олимп. Желаем вам приятной игры!`,
        inLanguage: this.inLanguage,
        applicationCategory: 'Game',
        applicationSubCategory: 'Slot Machine',
        genre: ['Slots', 'Online Slots', 'Casino Game'],
        datePublished: useSsrStore().gameObjectData.created,
        playMode: 'SinglePlayer',
        processorRequirements: '1 GHz',
        memoryRequirements: '1 Gb',
        storageRequirements: '2 Gb',
        gamePlatform: ['Browser', 'Flash', 'HTML5', 'PC game', 'Andorid', 'IOS'],
        operatingSystem: ['Multi-platform', 'Windows', 'Andorid', 'IOS', 'Linux'],
        author: this.author(),
        translator: this.translator(),
        publisher: this.publisher(),
      },

      breadcrumb: this.breadcrumb([
        {
          type: 'Thing',
          '@id': `${this.URL}/ru/games/${this.manufacturer.code}/`,
          name: `⚡${this.capitalizeProvider()}`,
        },
        {
          type: 'WebPage',
          '@id': `${this.URL}/ru/games/${this.manufacturer.code}/${useSsrStore().gameObjectData.slug}`,
          name: `🎰${useSsrStore().gameObjectData.name}`,
        },
      ]),
    }

    if (image) {
      const finalImage = `${this.URL}/${image}`
      json.primaryImageOfPage = {
        '@type': 'ImageObject',
        url: finalImage,
        contentUrl: finalImage,
        width: '240',
        height: '160',
      }
      json.potentialAction.target.actionApplication.image = finalImage
      json.mainEntity.image = finalImage
    }

    return JSON.stringify(json)
  }
}
